const useImpersonateUser = (eventId) => 
{
  const login = (type, token, eventId) => {
    if (type === "PARENTS") {
      window.open(
        `${process.env.REACT_APP_PARENTS_PORTAL_URL}/impersonate?token=${token}&eventId=${eventId}`,
        '_blank'
      ).focus()
    }

    if (type === "STAFF") {
      localStorage.setItem('impersonatorToken', localStorage.getItem('adminToken'))
      localStorage.setItem('adminToken', token)
      localStorage.setItem('impersonated', true)
      localStorage.setItem('impersonationActivatedFromLink', window.location.href)
      window.location.href = `/event/${eventId}/schedule`
    }
  }

  const logoutStaff = () => {
    let redirectUrl = "/"

    if (typeof window === 'undefined') return; // SSR guard

    const impersonatorToken = localStorage.getItem('impersonatorToken')
    localStorage.removeItem('impersonated')
    localStorage.removeItem('impersonatorToken')
    
    if (impersonatorToken) {
      localStorage.setItem('adminToken', impersonatorToken);
    } else {
      localStorage.removeItem('adminToken');
    }

    if (localStorage.getItem('impersonationActivatedFromLink')) {
      redirectUrl = localStorage.getItem('impersonationActivatedFromLink')
      localStorage.removeItem('impersonationActivatedFromLink')
    }

    window.location.href = redirectUrl
  }

  return { login, logoutStaff }
}

export default useImpersonateUser

